import moment from "moment";
import { useEffect, useState } from "react";
import OfflineModal from "../../OfflineLeads/OfflineModal";
import PayoutModal from "../PayoutModal";
import AllPayoutsSearch from "./AllPayoutsSearch";

const AllPayouts = (props) => {
  const isAdmin = props?.$store?.user?.role === _enum.ROUTE_PERSONAS.admin;
  const [isFetching, setIsFetching] = useState(true);
  const [search, setSearch] = useState({
    page: 1,
    limit: 10,
  });
  const [rowcount, setRowcount] = useState(0);
  const [data, setData] = useState([]);
  const columns = [
    {
      dataIndex: "borrower_full_name",
      title: "Connector Name",
      render: (text, record) => {
        return <span className="table-primary-text">{text}</span>;
      },
    },
    {
      dataIndex: "borrower_mobile_number",
      title: "Connector Mobile No.",
      render: (text, record) => {
        return <span className="table-primary-text">{text}</span>;
      },
      display: isAdmin ? true : false,
    },
    {
      dataIndex: "application_number",
      title: "Application No.",
    },
    {
      dataIndex: "lender_bank_name",
      title: "Bank Name",
    },
    {
      dataIndex: "loan_disbursed_amount",
      title: "Disb. Amt.",
      render: (text) => {
        return <>{text?.cur(0) || "-"}</>;
      },
    },
    {
      dataIndex: "loan_disbursement_date",
      title: "Disb. Date",
      render: (text, record) => {
        if (record?.loan_disbursement_date) {
          let date = new Date(text).dateToDDMMYYYY(new Date(text));
          return date;
        } else {
          return "-";
        }
      },
    },
    {
      dataIndex: "application_status",
      title: "Payment Status",
      render: (text) => {
        return (
          <AppTag color={_enum.STATUS_COLOR_MAP[text.toLowerCase()]}>
            {text?.toTitleCase() || "-"}
          </AppTag>
        );
      },
    },
  ];
  //   PAYOUT MODAL

  const [modalFields, setModalFields] = useState([
    {
      label: "Loan Info:",
      name: "loanInfo",
      type: "textarea",
      customcolspan: 12,
      outerclass: "form-title",
    },
    {
      label: "Customer Name",
      name: "connectorName",
      type: "text",
      placeholder: "Please Enter",
      required: true,
    },
    {
      label: "Digi Team Member Mobile No.",
      name: "mobileNo",
      type: "number",
      placeholder: "Please Enter",
      required: true,
    },
    {
      label: "Customer Name (as per PAN)",
      name: "applicantName",
      type: "text",
      placeholder: "Please Enter",
      required: true,
    },
    {
      label: "Mobile No.",
      name: "mobileNo",
      type: "number",
      placeholder: "Please Enter",
      required: true,
    },
    {
      label: "Product Type",
      name: "productType",
      type: "text",
      placeholder: "Please Enter",
      required: true,
    },
    {
      label: "Bank Name",
      name: "bankName",
      type: "text",
      placeholder: "Please Enter",
      required: true,
    },
    {
      label: "Loan Amount",
      name: "loanAmt",
      type: "number",
      placeholder: "Please Enter",
      required: true,
    },
    {
      label: "Loan Status",
      name: "loanStatus",
      type: "text",
      placeholder: "Please Enter",
      required: true,
    },
    {
      label: "Application No. ",
      name: "applicationNo",
      type: "text",
      placeholder: "Please Enter",
    },
    {
      label: "Application Date ",
      name: "createdAt",
      type: "date",
      disabledDate: (current) => {
        return current && current > moment().endOf("day");
      },
      placeholder: "Please Enter",
    },
    {
      label: "Disb. Amount",
      name: "disbursedAmt",
      type: "number",
      placeholder: "Please Enter",
    },
    {
      label: "Disb. Date",
      name: "disbursedDate",
      type: "date",
      disabledDate: (current) => {
        return current && current > moment().endOf("day");
      },
      placeholder: "Please Enter",
    },
    {
      label: "Payout Type",
      name: "payoutType",
      type: "select",
      options: _enum.PAYOUT_TYPES,
      placeholder: "Please Enter",
      required: true,
    },
    {
      label: "LAN",
      name: "lan",
      type: "number",
      placeholder: "Please Enter",
    },
    // PAYOUT INFO FIELDS
    {
      label: "Digi Team Member Payout %",
      name: "digirepPayoutPct",
      type: "number",
      step: ".01",
      placeholder: "Please Enter",
      onChange: (...args) => handleDigirepPayoutPct(...args),
    },
    {
      label: "Digi Team Member Payout Amt.",
      name: "digirepPayoutAmt",
      type: "number",
      step: ".01",
      placeholder: "Please Enter",
    },
    {
      label: "TDS %",
      name: "tdsPct",
      type: "number",
      step: ".01",
      placeholder: "Please Enter",
      onChange: (...args) => handleTDSPct(...args),
    },
    {
      label: "TDS Amt.",
      name: "tdsAmt",
      type: "number",
      step: ".01",
      placeholder: "Please Enter",
    },
    {
      label: "Net Payout Amt.",
      name: "netAmt",
      type: "number",
      step: ".01",
      placeholder: "Please Enter",
    },
    {
      label: "Payment Status",
      name: "paymentStatus",
      type: "select",
      onChange: (...args) => handlePaymentStatus(...args),
      options: isAdmin ? _enum.ADMIN_PAYOUT_STATUS : _enum.PAYOUT_STATUS,
      placeholder: "Please Enter",
    },
    {
      label: "Bank Payout %",
      name: "bankPayoutPct",
      type: "number",
      step: ".01",
      placeholder: "Please Enter",
      onChange: (...args) => handleBankPayoutPct(...args),
    },
    {
      label: "Bank Payout Amt.",
      name: "bankPayoutAmt",
      type: "number",
      step: ".01",
      placeholder: "Please Enter",
    },
    {
      label: "Payment Date",
      name: "paymentDate",
      type: "date",
      disabledDate: (current) => {
        return current && current > moment().endOf("day");
      },
      placeholder: "Please Enter",
    },
    {
      label: "Bank Payout Received Date",
      name: "bankPayoutReceiveDate",
      type: "date",
      disabledDate: (current) => {
        return current && current > moment().endOf("day");
      },
      placeholder: "Please Enter",
    },
    {
      label: "Remarks",
      name: "remarks",
      type: "textarea",
      customcolspan: 12,
    },
    {
      label: "Payout Info:",
      name: "payoutInfo",
      type: "textarea",
      customcolspan: 12,
      outerclass: "form-title my-3",
    },
  ]);
  const [editmode, setEditmode] = useState(false);
  const [viewmode, setViewmode] = useState(false);
  const [openCanvas, setOpenCanvas] = useState(false);
  const [editData, setEditData] = useState({});
  const [popupdata, setPopupdata] = useState({});
  const [popupfields, setPopupfields] = useState({});
  const [disabledFields, setDisabledFields] = useState([]);
  // ----------------------------------------------------------------

  const [applModalFields, setApplModalFields] = useState([
    {
      name: "leadName",
      label: "Customer Name",
      type: "text",
      placeholder: "Please enter",
      required: true,
      onChange: (value) => handleCustName(value),
    },
    {
      name: "mobileNumber",
      label: "Mobile No.",
      type: "text",
      placeholder: "Please enter",
      required: true,
      onChange: (value) => handleMobileNo(value),
    },
    {
      name: "productType",
      label: "Product Type",
      type: "select",
      options: [],
      placeholder: "Please enter",
      // outerclass: "readonly_field",
      required: true,
    },
    {
      name: "bankName",
      label: "Bank Name",
      type: "select",
      options: [],
      placeholder: "Please enter",
      required: true,
    },
    {
      name: "loanAmount",
      label: "Loan Amount",
      type: "text",
      placeholder: "Please enter",
      required: true,
      onChange: (value) => handleLoanAmount(value),
    },
    {
      name: "applicationNumber",
      label: "Application No.",
      type: "text",
      required: true,
      placeholder: "Please enter",
    },
    {
      name: "applicationDate",
      label: "Application Date",
      type: "date",
      disabledDate: (current) => {
        return current && current > moment().endOf("day");
      },
      placeholder: "Please enter",
      required: true,
    },
    // {
    //   name: "status",
    //   label: "Application Status",
    //   type: "select",
    //   options: _enum.LOAN_STATUS_NEW,
    //   placeholder: "Please select",
    //   required: true,
    //   onChange: (value) => handleApplicationStatus(value),
    // },
    // {
    //   label: "Payout Type",
    //   name: "payoutType",
    //   type: "select",
    //   options: _enum.PAYOUT_TYPES,
    //   placeholder: "Please Enter",
    //   required: true,
    // },
    {
      name: "disbursementAmount",
      label: "Disb. Amount",
      type: "text",
      placeholder: "Please enter",
      onChange: (value) => handleDisbAmount(value),
      required: true,
      // outerclass: "d-none",
    },
    {
      name: "disbursementDate",
      label: "Disb. Date",
      type: "date",
      // disabledDate: (current) => {
      //   return current && current > moment().endOf("day");
      // },
      placeholder: "Please enter",
      required: true,
      // outerclass: "d-none",
    },
  ]);

  const toastConfig = {
    autoClose: 3000,
    closeButton: false,
    hideProgressBar: true,
  };

  const handleCustName = (e) => {
    const stringReg = _enum?.REGEX?.onlystring;
    if (stringReg.test(e.target.value)) setErrorMessageAppl("");
    else
      setErrorMessageAppl({
        name: "leadName",
        message: "Special characters are not allowed",
      });
  };

  const handleMobileNo = (e) => {
    const numberReg = _enum?.REGEX?.number;
    const fieldValue = e.target.value;
    if (numberReg.test(fieldValue) && fieldValue.length === 10)
      setErrorMessageAppl("");
    else
      setErrorMessageAppl({
        name: "mobileNumber",
        message: "Please enter a valid Mobile Number",
      });
  };

  const handleLoanAmount = (e) => {
    const numberReg = _enum?.REGEX?.number;
    const fieldValue = e.target.value;
    if (numberReg.test(fieldValue)) setErrorMessageAppl("");
    else
      setErrorMessageAppl({
        name: "loanAmount",
        message: "Please enter a valid Loan Amount",
      });
  };

  const handleApplicationStatus = (val) => {
    console.log("value: ", val[0]?.key);
    let value = val[0]?.key;

    let disbAmntOuter = document.querySelector(
      "[name='appinput-disbursementAmount']"
    );

    let disbAmntInput = document.querySelector(
      "[name='appinput-disbursementAmount'] input"
    );

    let disbDateOuter = document.querySelector(
      "[name='appinput-disbursementDate']"
    );

    let disbDateInput = document.querySelector(
      "[name='appinput-disbursementDate'] input"
    );

    if (value !== _enum?.LOAN_STATUS_MAP?.disbursed) {
      disbDateOuter.classList.add("d-none");
      disbAmntOuter.classList.add("d-none");
      disbAmntInput.required = false;
      disbDateInput.required = false;
    } else {
      disbDateOuter.classList.remove("d-none");
      disbAmntOuter.classList.remove("d-none");
      disbAmntInput.required = true;
      disbDateInput.required = true;
    }
  };

  const handleDisbAmount = (e) => {
    const numberReg = _enum?.REGEX?.number;
    const fieldValue = e.target.value;
    if (numberReg.test(fieldValue)) setErrorMessageAppl("");
    else
      setErrorMessageAppl({
        name: "disbursementAmount",
        message: "Please enter a valid Disbursement Amount",
      });
  };

  const [errorMessageAppl, setErrorMessageAppl] = useState({
    name: "",
    message: "",
  });
  const [editDataAppl, setEditDataAppl] = useState({});
  const [editmodeAppl, setEditmodeAppl] = useState(false);
  const [viewmodeAppl, setViewmodeAppl] = useState(false);
  const [openCanvasAppl, setOpenCanvasAppl] = useState(false);
  const [popupfieldsAppl, setPopupfieldsAppl] = useState({});
  const [popupdataAppl, setPopupdataAppl] = useState({});

  const addModalFieldsAppl = (values) => {
    setEditmodeAppl(false);
    setViewmodeAppl(false);

    let fields = (applModalFields || []).reduce(
      (o, n) => ({ ...o, [n.name]: n }),
      {}
    );
    let formdata = Object.map(fields, (v, k) => "");
    // console.log("formdata: ", fields, formdata);

    setPopupfieldsAppl(fields);
    setPopupdataAppl(formdata);
    setOpenCanvasAppl(true);
  };

  const onModalCloseAppl = () => {
    setPopupfieldsAppl({});
    setViewmodeAppl(false);
    setEditmodeAppl(false);
    setEditDataAppl({});
    closeModalAppl();
  };

  const openModalAppl = () => {
    setOpenCanvasAppl(true);
  };

  const closeModalAppl = () => {
    setOpenCanvasAppl(false);
  };

  const getBankNames = () => {
    let payload = {
      page: 1,
    };
    props.apis.apiGetBanknames(payload).then((data) => {
      let bankNameField = applModalFields.find((o) => o.name === "bankName");
      bankNameField.options = data;
      setApplModalFields([...applModalFields]);
    });
  };

  const getProductTypes = () => {
    props.apis.apiGetProductTypes().then((res) => {
      let productType = applModalFields.find((o) => o.name == "productType");
      productType.options = res;
      setApplModalFields([...applModalFields]);
    });
  };

  const handleSubmitAppl = (e, data, form) => {
    e.preventDefault();
    console.log("formdata: ", data);
    let formdata = data;
    let cansubmit = true;
    let addPayload = {
      ...Object.except(formdata, [
        "loanAmount",
        "productType",
        "applicationDate",
      ]),
    };

    addPayload.loanAmount = Number(formdata.loanAmount);
    addPayload.productType = String(formdata.productType);
    addPayload.payoutType = "monthly";
    // addPayload.channel_type = "Offline";
    // addPayload.login_status = _enum?.LOAN_STATUS_MAP?.applied;
    // addPayload.status = _enum?.LOAN_STATUS_MAP?.disbursed;
    if (addPayload.disbursementAmount) {
      addPayload.disbursementAmount = Number(formdata.disbursementAmount);
    }
    if (addPayload.disbursementDate) {
      addPayload.disbursementDate = new Date(
        formdata.disbursementDate
      ).toISOString();
    }
    if (formdata?.applicationDate) {
      addPayload.applicationDate = new Date(
        formdata?.applicationDate
      ).toISOString();
    } else {
      cansubmit = false;
      toast.error("Required fields cannot be empty", toastConfig);
    }

    // if (data.status !== _enum?.LOAN_STATUS_MAP?.disbursed) {
    //   addPayload.disbursementAmount = null;
    //   addPayload.disbursementDate = null;
    // } else if (
    //   (data.status === _enum?.LOAN_STATUS_MAP?.disbursed &&
    //     addPayload.disbursementAmount === "") ||
    //   addPayload.disbursementDate === ""
    // ) {
    //   cansubmit = false;
    //   toast.error("Required fields cannot be empty", toastConfig);
    // } else {
    //   addPayload.disbursementAmount = Number(formdata.disbursementAmount);
    //   addPayload.disbursementDate = new Date(
    //     formdata.disbursementDate
    //   ).toISOString();
    //   cansubmit = true;
    // }

    console.log({ addPayload, cansubmit });
    if (cansubmit) {
      if (editmodeAppl) {
        // props.apis
        //   .apiUpdateApplication(addPayload, {
        //     applicationLeadId: editDataAppl?.applicationLeadId,
        //   })
        //   .then((response) => {
        //     console.log({ apiUpdateApplication: response });
        //     let filteredData = Object.only(
        //       response,
        //       applModalFields.map((v) => v.name)
        //     );
        //     console.log({ filteredData });
        //     setPopupdataAppl(filteredData);
        //     setEditDataAppl(response.data);
        //     closeModalAppl();
        //     swal2.fire({
        //       title: "Lead updated successfully !!",
        //       icon: "success",
        //       iconColor: "#234C9B",
        //       timer: 4000,
        //     });
        //     getData();
        //   })
        //   .catch((err) => {
        //     console.log(err);
        //   });
      } else {
        props.apis
          .apiAddConnectorPayout(Object.removeEmptyProps(addPayload))
          .then((res) => {
            console.log({ apiAddOfflineLeads: res });
            closeModalAppl();
            getData();
            swal2.fire({
              title: "Application added successfully.",
              icon: "success",
              iconColor: "#234C9B",
              timer: 4000,
            });
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }
  };

  // ----------------------------------------------------------------

  const getData = (params = {}, reset) => {
    let payload = {};
    if (reset) {
      let defaultSearchData = Object.only(search, ["page", "limit"]);

      setSearch(defaultSearchData);
      payload = {
        ...defaultSearchData,
      };
      console.log({ defaultSearchData: payload });
    } else {
      payload = {
        ...search,
        ...params,
      };
    }

    if (!isAdmin) {
      props.apis
        .apiGetConnectorApplications(payload)
        .then(({ data, count }) => {
          console.log({ apiGetConnectorApplications: data });
          setData(data);
          setRowcount(count);
          setIsFetching(false);
        });
    } else {
      props.apis
        .apiGetApplicationPayoutInfo({ ...payload, application_status: "SEND_FOR_PAYOUT" })
        .then(({ data, count }) => {
          console.log({ apiGetApplicationPayoutInfo: data });
          setData(data);
          setRowcount(count);
          setIsFetching(false);
        });
    }
  };

  const onSearch = (data, reset) => {
    console.log("onSearch on pending", data, reset);
    if (Object.keys(data).length === 0) {
      setSearch({
        ...data,
        ...search,
      });
      getData(data, reset);
    } else {
      setSearch({
        ...data,
        ...search,
      });
      getData(data, reset);
    }
  };
  const onPageChange = (pageData) => {
    // console.log({ onPageChange: pageData });
    setSearch({
      page: pageData.current,
      limit: pageData.pageSize || pageData.defaultPageSize || 25,
    });
  };

  const view = (record) => {
    setEditmode(false);
    setViewmode(true);

    let payload = {
      leadId: record.leadId,
    };
    props.apis.apiGetConsolidatedAppsById(payload).then(({ data }) => {
      let loanInfoFields = [
        "loanInfo",
        "applicationNo",
        "applicantName",
        "mobileNo",
        "productType",
        "bankName",
        "loanAmt",
        "loanStatus",
        "disbursedAmt",
        "disbursedDate",
        "payoutType",
        // "application_date",
        "payoutInfo",
      ];

      let editdata = {
        // LOAN INFO DATA --------------------------------
        loanInfo: "",
        digi_team_member_name: data?.createdBy?.name,
        digi_team_member_mobile_no: data?.createdBy?.mobileNumber,
        ...Object.only(data, loanInfoFields),
        // application_date: new Date(data?.applicationDate).dateToDDMMYYYY(
        //   new Date(data?.applicationDate)
        // ),
      };

      if (isAdmin) {
        // PAYOUT INFO DATA --------------------------------
        editdata.payoutInfo = "";
        editdata.digirepPayoutPct = data?.digirepPayoutPct;
        editdata.digirepPayoutAmt = data?.digirepPayoutAmt;
        editdata.tdsPct = data?.tdsPct;
        editdata.tdsAmt = data?.tdsAmt;
        editdata.netAmt = data?.netAmt;
        editdata.paymentDate = data?.paymentDate || new Date();
        editdata.paymentStatus = data?.paymentStatus;
        editdata.bankPayoutPct = data?.bankPayoutPct;
        editdata.bankPayoutAmt = data?.bankPayoutAmt;
        editdata.bankPayoutReceiveDate =
          data?.bankPayoutReceiveDate || new Date();
        editdata.remarks = data?.remarks;
      }

      let fields = (modalFields || []).reduce(
        (o, n) => ({ ...o, [n.name]: n }),
        {}
      );
      console.log({
        modalFields,
        editdata,
        fields,
      });
      setPopupfields(fields);

      if (isAdmin) {
        setPopupdata(editdata);
        updatefields("bankPayoutAmt", data?.bankPayoutAmt);
        updatefields("digirepPayoutAmt", data?.digirepPayoutAmt);
        updatefields("tdsAmt", data?.tdsAmt);
      } else {
        setPopupdata(
          Object.except(editdata, [
            "digi_team_member_name",
            "digi_team_member_mobile_no",
          ])
        );
      }
      setEditData(data);
      // ----------------------------------------------------------------
      let disabledFields = [
        "digi_team_member_name",
        "digi_team_member_mobile_no",
        "digirepPayoutAmt",
        "bankPayoutAmt",
        "tdsAmt",
        // "application_date",
        ...modalFields.map((field) => field.name),
      ];
      setDisabledFields(disabledFields);
      openModal();
    });
  };

  const edit = (record) => {
    if (record?.paymentStatus === "PROCESSED") {
      swal2.fire({
        title: "Processed lead cannot be edited",
        icon: "error",
        iconColor: "#FF4D4D",
        timer: 4000,
      });
    } else if (record?.paymentStatus === "PAID") {
      swal2.fire({
        title: "Paid lead cannot be edited",
        icon: "error",
        iconColor: "#FF4D4D",
        timer: 4000,
      });
    } else {
      setEditmode(true);
      setViewmode(false);

      let payload = {
        leadId: record.leadId,
      };
      props.apis.apiGetConsolidatedAppsById(payload).then(({ data }) => {
        let loanInfoFields = [
          "loanInfo",
          "applicationNo",
          "applicantName",
          "mobileNo",
          "productType",
          "bankName",
          "loanAmt",
          "loanStatus",
          "disbursedAmt",
          "disbursedDate",
          "payoutType",
          // "application_date",
          "payoutInfo",
        ];

        let editdata = {
          // LOAN INFO FIELDS --------------------------------
          loanInfo: "",
          digi_team_member_name: data?.createdBy?.name,
          digi_team_member_mobile_no: data?.createdBy?.mobileNumber,
          ...Object.only(data, loanInfoFields),
          // application_date: new Date(data?.applicationDate).dateToDDMMYYYY(
          //   new Date(data?.applicationDate)
          // ),
        };

        if (isAdmin) {
          // PAYOUT INFO DATA --------------------------------
          editdata.payoutInfo = "";
          editdata.digirepPayoutPct = data?.digirepPayoutPct;
          editdata.digirepPayoutAmt = data?.digirepPayoutAmt;
          editdata.tdsPct = data?.tdsPct;
          editdata.tdsAmt = data?.tdsAmt;
          editdata.netAmt = data?.netAmt;
          editdata.paymentDate = data?.paymentDate || new Date();
          editdata.paymentStatus = data?.paymentStatus;
          editdata.bankPayoutPct = data?.bankPayoutPct;
          editdata.bankPayoutAmt = data?.bankPayoutAmt;
          editdata.bankPayoutReceiveDate =
            data?.bankPayoutReceiveDate || new Date();
          editdata.remarks = data?.remarks;
        }

        let fields = (modalFields || []).reduce(
          (o, n) => ({ ...o, [n.name]: n }),
          {}
        );
        console.log({
          modalFields,
          editdata,
          fields,
        });

        setPopupfields(fields);
        setEditData(data);

        if (isAdmin) {
          setPopupdata(editdata);
          updatefields("bankPayoutAmt", data?.bankPayoutAmt);
          updatefields("digirepPayoutAmt", data?.digirepPayoutAmt);
          updatefields("tdsAmt", data?.tdsAmt);
        } else {
          setPopupdata(
            Object.except(editdata, [
              "digi_team_member_name",
              "digi_team_member_mobile_no",
            ])
          );
        }
        // ----------------------------------------------------------------
        let adminDisabledFields = [
          ...loanInfoFields,
          "digi_team_member_name",
          "digi_team_member_mobile_no",
          "digirepPayoutAmt",
          "bankPayoutAmt",
          "tdsAmt",
        ];

        let connectorDisabledFields = loanInfoFields.filter(
          (field) => field !== "payoutType"
        );
        // console.log({ adminDisabledFields, connectorDisabledFields });
        if (isAdmin) {
          setDisabledFields(adminDisabledFields);
        } else {
          setDisabledFields(connectorDisabledFields);
        }
        openModal();
      });
    }
  };

  const updatefields = (field, data) => {
    let fieldElem = modalFields.find((o) => o.name === field);
    // fieldElem.defaultValue = data;
    fieldElem.value = data;
  };
  // ----------------------------------------------------------------
  // PAYOUT INFO CALCULATION
  // 1. Bank Payout Amt = (Bank Payout) % of  Disb. Amount
  // 2. Digirep Payout Amt = (Digi Team Member Payout) % of Disb. Amount
  // 3. Net Payout Amt = Digirep Payout Amt - (TDS) % of  Digirep Payout Amt

  const handleBankPayoutPct = (e) => {
    let bankpct = Number(e.target.value);
    let disbursedAmtField = document.querySelector("[name='disbursedAmt']");

    const amount = disbursedAmtField.value;
    const percent = bankpct;
    const bankPayoutAmnt = (percent / 100) * amount;
    console.log({ amount, percent, bankPayoutAmnt });

    let bankPayoutAmtField = modalFields.find(
      (o) => o.name === "bankPayoutAmt"
    );

    // bankPayoutAmtField.defaultValue = bankPayoutAmnt;
    bankPayoutAmtField.value = bankPayoutAmnt;
    setModalFields([...modalFields]);
  };

  const handleDigirepPayoutPct = (e) => {
    let connectorpct = Number(e.target.value);
    let disbursedAmtField = document.querySelector("[name='disbursedAmt']");

    const amount = disbursedAmtField.value;
    const percent = connectorpct;
    const bankPayoutAmnt = (percent / 100) * amount;
    console.log({ amount, percent, bankPayoutAmnt });

    let digirepPayoutAmtField = modalFields.find(
      (o) => o.name === "digirepPayoutAmt"
    );

    digirepPayoutAmtField.value = bankPayoutAmnt;
    // ----------------------------------------------------------------
    setModalFields([...modalFields]);
  };

  const handleTDSPct = (e) => {
    let tdspct = Number(e.target.value);
    let netPayout, tdsAmount;
    let digirepPayoutAmtElem = document.querySelector(
      "[name='digirepPayoutAmt']"
    );

    let digirepPayoutAmt = Number(digirepPayoutAmtElem.value);

    if (tdspct === 0) {
      netPayout = 0;
      tdsAmount = 0;
    } else {
      tdsAmount = (tdspct / 100) * digirepPayoutAmt;

      netPayout = digirepPayoutAmt - digirepPayoutAmt * (tdspct / 100);
    }

    let netAmtField = modalFields.find((o) => o.name === "netAmt");
    netAmtField.value = netPayout;

    let tdsAmtField = modalFields.find((o) => o.name === "tdsAmt");
    tdsAmtField.value = tdsAmount;

    console.log({ tdspct, digirepPayoutAmt, netPayout, tdsAmount });
    setModalFields([...modalFields]);

    let fields = (modalFields || []).reduce(
      (o, n) => ({ ...o, [n.name]: n }),
      {}
    );

    setPopupfields(fields);
  };
  // ----------------------------------------------------------------

  const handlePaymentStatus = (values) => {
    let value = values[0].key;
    console.log({ value });

    let tfields = [
      "digirepPayoutPct",
      "digirepPayoutAmt",
      "tdsPct",
      "tdsAmt",
      "netAmt",
      "bankPayoutAmt",
      "paymentDate",
      "bankPayoutReceiveDate",
      "bankPayoutAmt",
      "bankPayoutPct",
    ];

    // if (value === "UNPAID") {
    //   tfields.forEach((field) => {
    //     let tfield = modalFields.find((o) => o.name === field);
    //     console.log(tfield);
    //     tfield.required = false;
    //   });
    //   setPayoutinfoFields([...modalFields]);
    // } else {
    //   tfields.forEach((field) => {
    //     let tfield = modalFields.find((o) => o.name === field);
    //     tfield.required = true;
    //   });
    //   setPayoutinfoFields([...modalFields]);
    // }
  };

  const handleSubmit = (e, data, form) => {
    e.preventDefault();
    console.log("formdata: ", data);
    let payload = {};

    if (!isAdmin) {
      payload.payoutType = data?.payoutType;
    } else {
      payload.tdsPct = Number(data?.tdsPct);
      payload.tdsAmt = Number(data?.tdsAmt);
      payload.netAmt = Number(data?.netAmt);
      payload.digirepPayoutPct = Number(data?.digirepPayoutPct);
      payload.digirepPayoutAmt = Number(data?.digirepPayoutAmt);
      payload.bankPayoutPct = Number(data?.bankPayoutPct);
      payload.bankPayoutAmt = Number(data?.bankPayoutAmt);
      payload.paymentStatus = data?.paymentStatus;
      payload.remarks = data?.remarks;

      if (data?.paymentDate?.length > 0) {
        payload.paymentDate = new Date(data?.paymentDate).toISOString();
      } else {
        payload.paymentDate = null;
      }
      if (data?.bankPayoutReceiveDate?.length > 0) {
        payload.bankPayoutReceiveDate = new Date(
          data?.bankPayoutReceiveDate
        ).toISOString();
      } else {
        payload.bankPayoutReceiveDate = null;
      }
    }

    console.log({ payload });

    props.apis
      .apiUpdateConsolidatedAppById(payload, {
        leadId: editData?.leadId,
      })
      .then((res) => {
        console.log({ apiUpdateConsolidatedAppById: res });
        swal2.fire({
          title: "Lead updated successfully.",
          icon: "success",
          iconColor: "#234C9B",
          timer: 4000,
        });
        closeModal();
        getData();
      });
  };

  const addModalFields = (values) => {
    let fields = (modalFields || []).reduce(
      (o, n) => ({ ...o, [n.name]: n }),
      {}
    );
    let formdata = Object.map(fields, (v, k) => "");
    console.log("formdata: ", fields, formdata);
    setPopupfields(fields);
    setPopupdata(formdata);
    setOpenCanvas(true);
  };

  const onModalClose = () => {
    console.log("onModalClose");
    closeModal();
    setPopupfields({});
    setViewmode(false);
    setEditmode(false);
    setEditData({});
    let bankPayoutAmtField = modalFields.find(
      (o) => o.name === "bankPayoutAmt"
    );
    let digirepPayoutAmtField = modalFields.find(
      (o) => o.name === "digirepPayoutAmt"
    );
    let tdsAmtField = modalFields.find((o) => o.name === "tdsAmt");
    digirepPayoutAmtField.defaultValue = "";
    digirepPayoutAmtField.value = "";

    bankPayoutAmtField.defaultValue = "";
    bankPayoutAmtField.value = "";

    tdsAmtField.defaultValue = "";
    tdsAmtField.value = "";

    // let netAmtField = modalFields.find((o) => o.name === "netAmt");
    // netAmtField.defaultValue = "";

    setModalFields([...modalFields]);
    // setEditData2({});
  };
  //   PAYOUT MODAL
  const openModal = () => {
    setOpenCanvas(true);
  };

  const closeModal = () => {
    setOpenCanvas(false);
  };

  useEffect(() => {
    // getBankNames();
    // getProductTypes();
    console.log({ editmodeAppl, viewmodeAppl });
  }, [openCanvasAppl]);
  // ----------------------------------------------------------------
  useEffect(() => {
    getData();
  }, []);
  return (
    <>
      <div className="d-flex align-items-center justify-content-end mb-3 float_top_lg">
        <AllPayoutsSearch
          onSearch={(...arg) => onSearch(...arg)}
          addModalFields={addModalFieldsAppl}
        />
      </div>
      <AppTable
        data={data}
        columns={columns}
        onChange={(...arg) => onPageChange(...arg)}
        total={rowcount}
        reorder={true}
        // editAction={(e) => edit(e)}
        // viewAction={(e) => view(e)}
        viewable={false}
        editable={false}
        deletable={false}
        loading={isFetching}
      ></AppTable>

      <OfflineModal
        id="applicationCanvas"
        title={`${
          editmodeAppl
            ? "Edit Payout"
            : viewmodeAppl
            ? "View Payout"
            : "Add Payout"
        }`}
        show={openCanvasAppl}
        onClose={() => onModalCloseAppl()}
        data={popupdataAppl}
        editdata={editDataAppl}
        fields={popupfieldsAppl}
        viewmode={viewmodeAppl}
        editmode={editmodeAppl}
        errorMessage={errorMessageAppl}
        // noValidate={true}
        onSubmit={(...args) => handleSubmitAppl(...args)}
        submitText={`${editmodeAppl ? "Update" : "Save & Submit"}`}
        disableallfields={viewmodeAppl ? true : false}
      />

      <PayoutModal
        id="payoutModal"
        title={`${editmode ? "Edit Lead" : viewmode ? "View Lead" : "Add"}`}
        show={openCanvas}
        onClose={() => onModalClose()}
        data={popupdata}
        // editdata={editData}
        fields={popupfields}
        editmode={editmode}
        viewmode={viewmode}
        onSubmit={(...args) => handleSubmit(...args)}
        submitText={`${editmode ? "Update" : "Submit"}`}
        disableallfields={viewmode ? true : false}
        disablefields={disabledFields}
      />
    </>
  );
};

export default constore(AllPayouts);
